import gql from 'graphql-tag';

export const GET_STUDENT_APPLICATION = gql`
  query ($id: ID!) {
    programmeChoiceMetadata {
      departments {
        value
        label
      }
      countryList {
        value
        label
      }
      rpgJoinPhdPartnerList {
        value
        label
      }
      prgCollabPhdPartnerList {
        value
        label
      }
    }

    application(id: $id) {
      programmeChoice {
        entryYear
        studyMode
        department
        programme
        programmeType
        partner {
          university
          universityCategory
          proposedChiefSupervisor
          isPolyUHomeUniversity
          physicalLocation
          partnerUniversityApplicationNo
        }
        researchArea
        proposedChiefSupervisor
        researchAreaBackup
        proposedChiefSupervisorBackup
        acceptNoResearchIndicator
      }

      hkpfsInformation {
        HKPFSReferenceNumber
      }

      distinctiveScholarships {
        files {
          name
          id
          link
        }
        fundingSource
        reason
      }

      researchExperiences {
        pastResearchExperience
        proposedResearchTopic
        proposedResearchPlan
        reasons
        longTermCareerPlan
        expectedContribution
        others
        researchProposal
      }

      academicQualifications {
        presentIndicator
        gpaIndicator
        rankIndicator
        academicCredentialIndicator
        degreeCertIndicator
        from
        to
        studyMode
        institution {
          country
          name
        }
        instructionMedium
        otherInstructionMedium
        currentStudyYear
        studyField
        degreeLevel
        qualificationMeans
        programmeName
        qualificationStatus
        academicOnlineVerificationCode
        degreeOnlineVerificationCode
        expectUpdateDate
        awardDate
        awardClassification
        withdrawDate
        officialClassRanking
        outOfRank
        officialMark
        convertGPARuleId
        outOfGpa
        marks {
          course
          credit
          result
        }
        markConversion {
          convertedMark
          letterToGPARule {
            name
          }
          digitToLetterRule {
            name
          }
        }
        certificates {
          id
          link
          name
        }
        transcripts {
          id
          link
          name
        }
        markExplanations {
          id
          link
          name
        }
        classRankProofs {
          id
          link
          name
        }
        otherDocuments {
          id
          link
          name
        }
      }

      languageQualifications {
        needEnglishTest
        testType
        testDate
        resultAnnouncedIndicator
        expectedResultUpdateDate
        referenceNo
        result {
          resultReceiptDate
          listening
          reading
          writing
          speaking
          overall
        }
        supportingDocuments {
          id
          link
          name
        }
      }

      otherTests {
        testType
        testDate
        resultAnnouncedIndicator
        expectedResultUpdateDate
        referenceNo
        result {
          resultReceiptDate
          totalScore
          totalPercentile
          quantitativeScore
          quantitativePercentile
          analyticalWritingScore
          analyticalWritingPercentile
          verbalScore
          verbalPercentile
          integratedReasoningScore
          integratedReasoningPercentile
          dataInsightsScore
          dataInsightsPercentile
        }
        supportingDocuments {
          id
          link
          name
        }
      }

      publications {
        publicationType
        publicationAuthors
        publicationTitle
        publicationName
        applicantRole
        specificRole
        publicationStatus
        publicationDate
        issuePageArticelNo
        peerReviewedIndicator
        citationInfo
        publicationUrl
        supportingDocuments {
          id
          link
          name
        }
      }

      merits {
        meritName
        awardBodyName
        awardDate
        country
        attainmentMeans
        supportingDocuments {
          id
          link
          name
        }
      }

      academicReferees {
        title
        name {
          surname
          givenName
        }
        institution
        position
        relationship
        email
        referenceReport {
          name
          id
          link
        }
      }

      employments {
        presentEmploymentIndicator
        from
        to
        employmentMode
        employmentField
        organisationName
        position
        majorResponsibilities
        supportingDocuments {
          id
          link
          name
        }
      }

      professionalQualifications {
        awardDate
        country
        professionField
        professionalQualification
        awardBodyName
        awardName
        attainmentMeans
        supportingDocuments {
          id
          link
          name
        }
      }

      trainings {
        from
        to
        presentTrainingIndicator
        country
        organisationName
        programmeName
        supportingDocuments {
          id
          link
          name
        }
      }

      activities {
        presentActivityIndicator
        from
        to
        activityType
        organisationName
        position
        majorResponsibilities
        supportingDocuments {
          id
          link
          name
        }
      }

      additionalDocuments {
        documentType
        supportingDocuments {
          id
          link
          name
        }
      }

      declaration {
        personalType
        confirmation
        informationAccuracy
        engagement
      }
    }
  }
`;

export const GET_NAME_BY_NET_ID = gql`
  query ($id: String!) {
    advancedUser(netId: $id) {
      givenName
      surname
    }
  }
`;
